export function EqualArrowIcon ({ title }) {
  return (
    <svg
      style={{ verticalAlign: 'bottom' }}
      width='16px'
      height='16px'
      viewBox='0 0 16 16'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <g
        id='equal'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M15,9.5 L15,11.5 L1,11.5 L1,9.5 L15,9.5 Z M15,4.5 L15,6.5 L1,6.5 L1,4.5 L15,4.5 Z'
          id='Combined-Shape'
          fill='#9a9797'
          fillRule='nonzero'
        />
      </g>
    </svg>
  )
}
